module.exports = __webpack_public_path__ + "img/Icon2.bd459b97.svg";